import React from 'react'
import UpdatePowerBreadCrumb from './UpdatePowerBreadCrumb';
import UpdatePowerGenerationPlant from './UpdatePowerGenerationPlant';
function UpdatePowerGenerationPlantPage() {
    return ( 
        <div className= "container-fluid">
            <UpdatePowerBreadCrumb />
            <UpdatePowerGenerationPlant />
        </div>
     );
}

export default UpdatePowerGenerationPlantPage;